import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "data-epoch-id"]
const _hoisted_2 = { class: "epoch__text" }
const _hoisted_3 = { "data-initalfontsize": "36" }
const _hoisted_4 = { class: "epoch__toggle-btn-wrapper" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "epoch__content" }

import type { IEpoch } from "@features/Pages/TimelineMapPage/_js/app/interfaces/IEpoch";
import type { ITranslations } from "@features/Pages/TimelineMapPage/_js/app/interfaces/ITranslations";
import MomentVRAK from "../moment/MomentVRAK.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EpochVRAK',
  props: {
    epoch: {},
    translations: {}
  },
  emits: ["toggle-epoch"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onToggleEpoch(event: MouseEvent) {
  emit("toggle-epoch", { epoch: props.epoch, event });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "epoch",
    id: `epoch-id-${__props.epoch.id}`,
    "data-epoch-id": __props.epoch.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.epoch.epochYearName), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "epoch__toggle-btn btn btn--white-bg-on-hover",
        type: "button",
        onClick: onToggleEpoch,
        "aria-pressed": "false",
        "aria-label": `${ __props.translations.show } / ${ __props.translations.close } ${__props.epoch.epochYearName}`
      }, _toDisplayString(__props.translations.show), 9 /* TEXT, PROPS */, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.epoch.timelineMapItems, (moment) => {
        return (_openBlock(), _createBlock(MomentVRAK, {
          key: moment.urlSegment ?? moment.id,
          moment: moment,
          "epoch-id": __props.epoch.id,
          translations: __props.translations
        }, null, 8 /* PROPS */, ["moment", "epoch-id", "translations"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})